// src/api/photoface.api.js
// طبقة الاتصال بخدمة PhotoFace عبر باكند النظام (photoface-albums)
import axiosInstance from './axiosInstance';

/** ألبومات PhotoFace لحجز معين */
export const fetchPhotoFaceAlbums = (bookingId) =>
  axiosInstance.get('/photoface-albums/', { params: { booking: bookingId } });

/** إنشاء ألبوم جديد مرتبط بالحجز */
export const createPhotoFaceAlbum = (bookingId, name) =>
  axiosInstance.post('/photoface-albums/', { booking: bookingId, name });

/** حذف الألبوم (حذف ناعم محلياً + حذف فعلي في PhotoFace) */
export const deletePhotoFaceAlbum = (id) =>
  axiosInstance.delete(`/photoface-albums/${id}/`);

/** الحالة الحية (عدد الصور / جاري المعالجة / الرابط فعال) */
export const fetchLiveStatus = (id) =>
  axiosInstance.get(`/photoface-albums/${id}/live_status/`);

/** صور الألبوم (مقسمة صفحات) */
export const fetchAlbumPhotos = (id, page = 1, pageSize = 24) =>
  axiosInstance.get(`/photoface-albums/${id}/photos/`, {
    params: { page, page_size: pageSize },
  });

/** طلب روابط رفع مباشرة إلى S3 — files: [{name, size, type}] */
export const requestUploadUrls = (id, files) =>
  axiosInstance.post(`/photoface-albums/${id}/upload-urls/`, { files });

/** تأكيد الرفع وبدء فهرسة الوجوه */
export const confirmUpload = (id, s3Keys) =>
  axiosInstance.post(`/photoface-albums/${id}/confirm-upload/`, { s3_keys: s3Keys });

/** توليد رابط الضيف + QR — المدة بالساعات (إدخال حر) */
export const generateLink = (id, durationHours) =>
  axiosInstance.post(`/photoface-albums/${id}/generate-link/`, {
    duration_hours: durationHours,
  });

/** إلغاء رابط الضيف فوراً */
export const revokeLink = (id) =>
  axiosInstance.post(`/photoface-albums/${id}/revoke-link/`);

/** رصيد حساب الخدمة (الكردتس والمساحة) */
export const fetchCredits = () =>
  axiosInstance.get('/photoface-albums/credits/');

/** تفعيل/إيقاف النمط الآمن (المراجعة اليدوية قبل ظهور الصور للضيوف) */
export const setReviewMode = (id, enabled) =>
  axiosInstance.post(`/photoface-albums/${id}/review-mode/`, { enabled });

/** حذف صورة واحدة من الألبوم */
export const deleteAlbumPhoto = (id, photoId) =>
  axiosInstance.delete(`/photoface-albums/${id}/photos/${photoId}/`);

/** رابط مشاركة مباشر لصورة (صالح 24 ساعة) */
export const sharePhoto = (id, photoId) =>
  axiosInstance.get(`/photoface-albums/${id}/photos/${photoId}/share/`);

/** تعديل ملاحظة صورة */
export const updatePhotoNote = (id, photoId, note) =>
  axiosInstance.patch(`/photoface-albums/${id}/photos/${photoId}/note/`, { note });

/** طلبات المراجعة اليدوية للألبوم (مع روابط مجددة للصور المرشحة) */
export const fetchReviewRequests = (id) =>
  axiosInstance.get(`/photoface-albums/${id}/requests/`);

/** الموافقة على طلب مراجعة مع الصور المختارة */
export const approveReviewRequest = (id, requestId, selectedPhotoIds) =>
  axiosInstance.post(`/photoface-albums/${id}/requests/${requestId}/approve/`, {
    selected_photo_ids: selectedPhotoIds,
  });

/** رفض طلب مراجعة */
export const rejectReviewRequest = (id, requestId) =>
  axiosInstance.post(`/photoface-albums/${id}/requests/${requestId}/reject/`);

/**
 * رفع ملف إلى S3 عبر الباكند (حاوية أمازون تسمح بأصل PhotoFace فقط،
 * فيرفع السيرفر نيابة عن المتصفح باستخدام presigned URL).
 */
export const proxyUploadToS3 = (albumId, file, uploadUrl, contentType) => {
  const form = new FormData();
  form.append('file', file);
  form.append('upload_url', uploadUrl);
  form.append('content_type', contentType || 'image/jpeg');
  return axiosInstance.post(`/photoface-albums/${albumId}/proxy-upload/`, form);
};
